
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class extends Vue {
  @Prop() private menuTitle!: string
  private linkArray = [
    {
      title: require('@/assets/images/exam/001.png'),
      url: 'https://www.acftu.org/'
    },
    {
      title: require('@/assets/images/exam/002.png'),
      url: 'http://www.mohrss.gov.cn/'
    },
    {
      title: require('@/assets/images/exam/003.png'),
      url: 'http://www.most.gov.cn/'
    },
    {
      title: require('@/assets/images/exam/004.png'),
      url: 'https://www.miit.gov.cn/'
    },
    {
      title: require('@/assets/images/exam/005.png'),
      url: 'https://www.china-wdf.org.cn/'
    },
    {
      title: require('@/assets/images/exam/006.png'),
      url: 'http://www.wp-china.com/f'
    }
    // {
    //   title: require('@/assets/images/exam/07.png'),
    //   url: 'http://www.cscec7b.com/'
    // }
    // {
    //   title: require('@/assets/images/exam/07.png'),
    //   url: 'http://www.nestle.com.cn'
    // },
    // {
    //   title: require('@/assets/images/exam/008.png'),
    //   url: 'http://www.lenovo.com.cn/'
    // },
    // {
    //   title: require('@/assets/images/exam/09.png'),
    //   url: 'http://www.szyuto.com'
    // },
    // {
    //   title: require('@/assets/images/exam/10.png'),
    //   url: 'http://www.jinjia.com'
    // },
    // {
    //   title: require('@/assets/images/exam/11.png'),
    //   url: 'http://www.packagetest.net'
    // },
    // {
    //   title: require('@/assets/images/exam/12.png'),
    //   url: 'http://www.jiangnan.edu.cn/'
    // },
    // {
    //   title: require('@/assets/images/exam/13.png'),
    //   url: 'http://www.whu.edu.cn/'
    // },
    // {
    //   title: require('@/assets/images/exam/14.png'),
    //   url: 'http://www.zstu.edu.cn/'
    // },
    // {
    //   title: require('@/assets/images/exam/18.png'),
    //   url: 'http://www.hut.edu.cn/'
    // },
    // {
    //   title: require('@/assets/images/exam/19.png'),
    //   url: 'http://www.bigc.edu.cn/'
    // }
  ]

  link (item: any) {
    const url = item.url
    window.open(url, '_blank')
  }
}
